<ng-template #template>
  <ng-container *ngIf="isNeedRenderWrapper">
    <div *ngIf="components.length > 0" [class]="'sv-components-column' + ' sv-components-container-' + container">
      <ng-container *ngFor="let component of components">
        <ng-template [component]="{ name: component.component, data: { survey: survey, container: container, model: component.data } }"></ng-template>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="!isNeedRenderWrapper && components.length > 0">
    <ng-container *ngFor="let component of components">
      <ng-template [component]="{ name: component.component, data: { survey: survey, container: container, model: component.data } }"></ng-template>
    </ng-container>
  </ng-container>
</ng-template>